import {
  selectIsEmbeddedMessagingCoreFeatureFlagOn,
  selectUserRbacPermissions,
} from 'core/userContext';
import { MEDIUM_OPTIONS } from 'modules/quickActionsMenu/constants';
import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import { PAGE } from 'modules/quickActionsMenu/types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { Item } from '../Item';
import { CommandEmpty, CommandGroup, CommandList } from '../Styled';

const TemplateMediumsGated = () => {
  const { pageState, selectPage } = useQuickActionsMenuContext();
  const isEmbeddedMessagingCoreEnabled = useSelector(selectIsEmbeddedMessagingCoreFeatureFlagOn);
  const templateMediumOptions = Object.values(MEDIUM_OPTIONS).filter((option) =>
    !isEmbeddedMessagingCoreEnabled ? option.id !== 'embedded' : option,
  );
  return (
    <CommandList>
      <CommandEmpty>No matching results</CommandEmpty>
      <CommandGroup heading="Template mediums">
        {templateMediumOptions.map((medium) => {
          const { Icon, id, label } = medium;
          return (
            <Item
              Icon={<Icon />}
              key={id}
              name={label}
              onSelect={() => {
                selectPage({
                  data: { templateMedium: id },
                  page: PAGE.TEMPLATE_CREATION,
                  previousPage: pageState?.page,
                });
              }}
              value={label}
            />
          );
        })}
      </CommandGroup>
    </CommandList>
  );
};

export const TemplateMediums = () => {
  const permissions = useSelector(selectUserRbacPermissions);
  const hasTemplatePermissions = useMemo(
    () => permissions.includes(PROJECT_PERMISSIONS.ManageBaseTemplates),
    [permissions],
  );

  return (
    <>
      {hasTemplatePermissions ? (
        <TemplateMediumsGated />
      ) : (
        <CommandEmpty>User does not have the required permissions</CommandEmpty>
      )}
    </>
  );
};
